<div class="counter-flex">
  <input type="text" #input
    [style.overflow-y]="setVerticalScrollPolicy()" [tabindex]="tabEnabled ? tabindex : -1"
    class="text-label-required"
    [disabled]="disabled" [readonly]="!editable" [maxlength]="maxChars" [(ngModel)]="text" autocomplete="off"
    (ngModelChange)="onChange($event);textChanged()" plessInputTextCoopDeli [restrict]="restrict" [fullOnly]="fullOnly" [halfOnly]="halfOnly"
    [toUpperCase]="toUpperCase" [allowMultiLine]="allowMultiLine"
    [style.width]="width !== undefined ? width : '100%'"
    (blur)="onTouched();blur.emit($event);" (focus)="focus.emit($event);"
    [style.background-color]="bg"/>
  <label class="count-field" *ngIf="displayCountField" [style.width]="counterWidth">{{ count }}</label>
</div>
